import React, { Component } from 'react';
import Page from '../../containers/page';

import {
    Container,
    Row,
    Col, Input, Label, Modal, ModalBody, ModalHeader, FormGroup, Button, ButtonToggle, ModalFooter
} from 'reactstrap';

import { getSearchParams, generateSearchLink, generateSearchLinkMultiple } from '../../helpers/linkHelper';
import { API_ENDPOINT } from '../../constants';

import LandingBuilder from '../landingBuilder/landingBuilder'
import defaultJson from '../landingBuilder/default.json'
import defaultInformationJson from '../landingBuilder/defaultInfoPages.json'
import defaultLoginJson from '../landingBuilder/defaultLogin.json'

import { Player, Controls } from '@lottiefiles/react-lottie-player';
import { cleanLanding } from '../../appBuilder/helper';
import Checkbox from '../../components/forms/fields/checkbox';

import backIcon from '../../assets/svg/back-icon.svg';

import Isvg from 'react-inlinesvg'
import InformationPageLandingBuilder from './informationPageLandingBuilder';


function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}
function toSlug(text) {
    return text
        .toLowerCase()
        // .trim()
        .replace(/\s+/g, '-')            // Replace spaces with -
        .replace(/[^a-z0-9\-_]/g, '')    // Remove all non-word chars except - and _
        .replace(/\-+/g, '-');           // Replace multiple - with single -
}


class InformationPagesAddNew extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props.initialData,
            form: false,
            useState: false,
            params: {
                entries: 10,
                page: 0
            },
            // loading: true,
            data: {
                title: '',
                slug: '',
                isPrivate: false,
                landingStyle: defaultInformationJson,
            },
        };
    }
    resetData = () => {
        this.setState({
            data: {
                title: '',
                slug: '',
                isPrivate: false,
                landingStyle: defaultInformationJson,
            }
        });
    }


    get = () => {

    }

    initialGet = () => {
        const id = this.props[0].match.params.id;
        const groupId = this.props.selectedGroup;
        if (id != 'new') {
            fetch(API_ENDPOINT + `/landing/information-pages/${groupId}/${id}`, {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }
            }).then(parseJSON).then(({ result, status }) => {
                if (result?._id) {
                    let data = this.state.data;
                    if (result?._id) data._id = result._id;
                    if (result?.title) data.title = result.title;
                    if (result?.slug) data.slug = result.slug;
                    data.isPrivate = result.isPrivate ? true : false;
                    if (result?.landingStyle) data.landingStyle = result.landingStyle;
                    this.setState({ data: data, _initialData: JSON.parse(JSON.stringify(data)) });
                } else {
                    this.resetData();
                }
            })
        } else {
            this.resetData();
        }
    }

    componentDidMount() {
        if (typeof window !== 'undefined') { window.scrollTo(0, 0); }

        this.get();
        this.initialGet();
    }

    componentDidUpdate(prevProps) {
        if (prevProps?.selectedGroup !== this.props?.selectedGroup) {
            this.get();
            this.initialGet();
        }
    }

    insertOrUpdate = (callback) => {
        const id = this.props[0].match.params.id;
        const groupId = this.props.selectedGroup;
        const data = this.state.data;

        let obj = {
            ...data,
            groupId: groupId
        }
        let errorFields = {};
        if (!obj?.title) errorFields.title = 'Title is required';
        if (!obj?.slug) errorFields.slug = 'Slug is required';

        if (Object.keys(errorFields).length > 0) {
            this.setState({ errorFields });
            return;
        }

        this.setState({ loading: true, showPlayer: true }, () => {
            fetch(API_ENDPOINT + `/landing/information-pages/${id}`, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(obj)
            }).then(parseJSON).then(({ result, status }) => {
                if (result?.error) {
                    this.setState({ error: result.error, loading: false });
                } else {
                    this.setState({
                        showPlayer: false,
                        showPlayer2: true,
                        loading: false,
                        _initialData: JSON.parse(JSON.stringify(this.state.data)),
                    },
                        () => {
                            setTimeout(() => {
                                this.setState({ showPlayer2: false });
                            }, 1000);

                            if (this.props.groupSettingsModal)
                                this.props.abortAction();

                            this.checkIfNotSavedChangesExist();

                            if (id === 'new' && result?.id) {
                                this.props[0].history.push(`/my-data/information-pages/${result.id}`);
                            }
                        })


                    if (callback) callback();
                    // this.props[0].history.push(`/my-data/information-pages`);
                }
            })
        });

    }



    stopAnimation = () => {
        this.player?.current?.play();
    }

    checkIfNotSavedChangesExist = () => {
        const _data = this.state.data || {};
        const _initialData = this.state._initialData || {};

        const data = JSON.parse(JSON.stringify(_data));
        const initialData = JSON.parse(JSON.stringify(_initialData));

        let changedFields = Object.keys(data).filter(key => {
            if (JSON.stringify(data?.[key]) !== JSON.stringify(initialData?.[key])) {
                return true;
            }
            return false;
        });
        if (changedFields?.length && !this.props.groupSettingsModal) {
            this.props.groupSettingsChanged();
        } else if (!changedFields?.length && this.props.groupSettingsModal) {
            this.props.abortAction();
        }
        return changedFields?.length ? true : false;
    }
    getGroupData = () => {
        let selectedGroupIdx = -1;
        if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                    selectedGroupIdx = i;
                    break;
                }
            }
        }
        const groupData = this.props.uData?.clinicGroups?.[selectedGroupIdx];

        return groupData;
    }
    generateInitialLink = () => {
        if (typeof window === 'undefined') return null;
        const groupData = this.getGroupData();
        const groupAlias = groupData?.alias;

        const endpoint = window.origin;

        const initialLink = `${endpoint}/${groupAlias}/page/`;

        return initialLink;

        // const slug = item?.slug;
        // if (!groupAlias || !slug) return;
        // let link;
        // if (typeof window !== 'undefined' && item) {
        //     let endpoint = window.origin;

        //     if (endpoint) {
        //         link = `${endpoint}/${groupAlias}/page/${slug}`;
        //         navigator.clipboard.writeText(link)
        //     }
        // }
        // //
        // if (link) {
        //     this.setState({ copiedToClipboard: item?._id }, () => {
        //         if (this.copyToClipboard) {
        //             clearTimeout(this.copyToClipboard)
        //         }
        //         this.copyToClipboard = setTimeout(() => {
        //             this.setState({ copiedToClipboard: false })
        //         }, 2000);
        //     })
        // }

    }

    render() {
        let params = {};
        if (this.state.useState) {
            params = this.state.params;
        } else {
            params = getSearchParams(this.props[0].location.search, { entries: 10, page: 0 })
        }

        const initialLink = this.generateInitialLink() || '';

        return (
            <div className={this.props.autoHideSidebar ? "dashboard dashboard-auto-hide" : "dashboard"}>

                <Container fluid>

                    <div className="panel panel-short">
                        <div className='forms-builder-title'>

                            <h4>{this.props[0].match.params.id == 'new' ? 'Add Information page'.translate(this.props.lang) : 'Edit Information page'.translate(this.props.lang)}</h4>
                            <Button color='primary' onClick={() => {
                                const check = this.checkIfNotSavedChangesExist();
                                if (check) {
                                    this.setState({ notSavedModal: true })
                                } else {
                                    let obj = {}
                                    if (this.props[0].location.state && this.props[0].location.state.redirectFrom) {
                                        obj = this.props[0].location.state.redirectFrom;
                                    }
                                    this.props[0].history.push({
                                        pathname: '/my-data/information-pages',
                                        state: {
                                            // initialState: obj
                                        }
                                    })
                                }

                            }}><Isvg src={backIcon} /></Button>
                        </div>
                        <Row>

                            <Col lg="6" xs="12">
                                <FormGroup className={this.state.errorFields?.title ? 'form-group-field-has-error' : ''}>
                                    <Label>{'Title*'.translate(this.props.lang)}</Label>
                                    <Input type="text"
                                        value={this.state.data.title}
                                        onChange={(e) => {
                                            let data = this.state.data;
                                            data.title = e.target.value;
                                            let setObj = { data };

                                            let errorFields = this.state.errorFields;
                                            if (errorFields?.title) {
                                                delete errorFields.title;
                                                setObj.errorFields = errorFields;
                                            }

                                            this.setState(setObj, () => {
                                                this.checkIfNotSavedChangesExist();
                                            });
                                        }}
                                    />
                                    {this.state.errorFields?.title ? <div className="form-group-field-error">{this.state.errorFields.title}</div> : null}
                                </FormGroup>
                            </Col>
                            <Col lg="6" xs="12">
                                <FormGroup className={this.state.errorFields?.slug ? 'form-group-field-has-error' : ''}>
                                    <Label>{'Slug*'.translate(this.props.lang)}</Label>
                                    {/* <div className='information-page-slug-input'>
                                        <Input type="text"
                                            value={initialLink}
                                            disabled={true}
                                            onChange={(e) => {
                                                return;
                                            }}
                                        /> */}
                                    <Input type="text"
                                        value={this.state.data.slug}
                                        onChange={(e) => {
                                            let value = toSlug(e.target.value);
                                            if (value.length > 50) value = value.substring(0, 50);
                                            let data = this.state.data;
                                            data.slug = value;

                                            let setObj = { data };

                                            let errorFields = this.state.errorFields;
                                            if (errorFields?.slug) {
                                                delete errorFields.slug;
                                                setObj.errorFields = errorFields;
                                            }

                                            this.setState(setObj, () => {
                                                this.checkIfNotSavedChangesExist();
                                            });
                                        }}
                                    />
                                    {/* </div> */}
                                    {this.state.errorFields?.slug ? <div className="form-group-field-error">{this.state.errorFields.slug}</div> : null}
                                </FormGroup>

                            </Col>
                            <Col lg="12" xs="12">
                                <FormGroup >
                                    <Checkbox
                                        checked={this.state.data.isPrivate}
                                        onChange={(e) => {
                                            let data = this.state.data;
                                            data.isPrivate = e.target.checked;
                                            this.setState({ data }, () => {
                                                this.checkIfNotSavedChangesExist();
                                            });
                                        }}
                                        label={'Is Private'.translate(this.props.lang)}
                                        tooltip={'Access to this information page requires the patient to be logged in'.translate(this.props.lang)}
                                    />

                                </FormGroup>
                            </Col>
                            <Col lg="12" xs="12">
                                <InformationPageLandingBuilder
                                    {...this.props}
                                    landingStyle={this.state.data?.landingStyle}
                                    loadingSave={this.state.loading}
                                    updateLandingStyle={(landingStyle) => {
                                        let data = this.state.data;
                                        data.landingStyle = landingStyle;
                                        this.setState({ data }, () => {
                                            this.checkIfNotSavedChangesExist();
                                        });
                                    }}
                                    saveHandler={() => {
                                        this.insertOrUpdate()
                                    }}
                                    showPlayer={this.state.showPlayer}
                                    showPlayer2={this.state.showPlayer2}
                                />

                            </Col>



                            <Col lg="12" xs="12">
                                <Button
                                    color='primary'
                                    disabled={this.state.loading}
                                    onClick={() => this.insertOrUpdate()}
                                    style={{ marginTop: 50, marginBottom: 20 }}
                                >
                                    {
                                        this.state.showPlayer ? (
                                            <Player
                                                onEvent={(event) => {
                                                    // if (event === "load") this.stopAnimation();
                                                }}
                                                // onStateChange={this.toggleVisibility}
                                                ref={this.player} // set the ref to your class instance
                                                autoplay={true}
                                                loop={true}
                                                controls={true}
                                                src="https://assets8.lottiefiles.com/packages/lf20_ZSRKCF.json"
                                                style={{ height: "20px", width: "20px" }}
                                            ></Player>

                                        ) : this.state.showPlayer2 ? (
                                            <div style={{ display: 'flex', alignItems: 'center' }}><Player
                                                // onStateChange={this.toggleVisibility}
                                                ref={this.player2} // set the ref to your class instance
                                                autoplay={true}
                                                loop={true}
                                                controls={true}
                                                src="https://assets10.lottiefiles.com/packages/lf20_CxyxLk.json"
                                                style={{ height: "20px", width: "20px" }}
                                            ></Player>
                                                {'Saved'.translate(this.props.lang)}
                                            </div>
                                        ) : (
                                            "Save".translate(this.props.lang)
                                        )
                                    }
                                </Button>
                            </Col>
                        </Row>





                        {/* <div>
                            <LandingBuilder {...this.props} landingStyle={this.state.landingStyle} clinicGroupsList={this.state.clinicGroupsList} />

                        </div> */}


                    </div>

                </Container>

                {this.state.notSavedModal || this.props.changeLinkModal ?
                    <Modal isOpen={this.state.notSavedModal || this.props.changeLinkModal} centered>
                        <ModalBody className="delete-modal">
                            <p className="message">{'Data is not saved, if you click Yes it will be deleted'.translate(this.props.lang)}</p>
                        </ModalBody>
                        <ModalFooter className='buttons-right-blue'>
                            <Button color="primary" style={{ margin: 10, minWidth: 100 }} onClick={() => {
                                this.props.abortAction(() => {
                                    this.insertOrUpdate(() => {
                                        this.props[0].history.push('/my-data/information-pages')
                                    });
                                })

                            }}>{'Save and exit'.translate(this.props.lang)}</Button>

                            <Button
                                color="primary"
                                style={{ margin: 10, minWidth: 100 }}
                                onClick={() => {
                                    this.props.abortAction(() => {
                                        this.props[0].history.push('/my-data/information-pages')
                                    })

                                }}>{'Exit without saving'.translate(this.props.lang)}</Button>

                            <Button color="primary" style={{ margin: 10, minWidth: 100 }} onClick={() => {
                                this.props.abortAction(() => {
                                    this.checkIfNotSavedChangesExist();
                                });
                                this.setState({ notSavedModal: null })
                            }}>{'Go back'.translate(this.props.lang)}</Button>

                        </ModalFooter>
                    </Modal>
                    : null}




            </div>
        );
    }
}

export default Page(InformationPagesAddNew);